export default {
  background: {
    default: "#d8ddd9",
  },

  text: {
    main: "#202A26",
    focus: "#00361F",
  },

  transparent: {
    main: "transparent",
  },

  white: {
    main: "#F9F9F7",
    focus: "#f0f2f5",
  },

  hover: {
    main: "#004C2A",
  },

  black: {
    light: "#000000",
    main: "#000000",
    focus: "#000000",
  },

  primary: {
    main: "#004C2A",
    focus: "#00361F",
  },

  secondary: {
    main: "#00361F",
    focus: "#00361F",
  },

  info: {
    main: "#1A73E8",
    focus: "#1662C4",
  },

  success: {
    main: "#4CAF50",
    focus: "#67bb6a",
  },

  warning: {
    main: "#fb8c00",
    focus: "#fc9d26",
  },

  error: {
    main: "#F44335",
    focus: "#f65f53",
  },

  light: {
    main: "#f0f2f5",
    focus: "#f0f2f5",
  },

  dark: {
    main: "#00361F",
    focus: "#00361F",
  },

  grey: {
    100: "#f9faf9",   // quase branco com leve tom oliva
    200: "#edf0ee",   // cinza claro esverdeado
    300: "#d8ddd9",   // cinza claro com leve verde
    400: "#c0c8c2",   // cinza neutro puxado pro verde
    500: "#a0aaa2",   // cinza médio, tom oliva discreto
    600: "#6e756f",   // escurecido, base verde acinzentada
    700: "#4a544d",   // tom denso, elegante, toque de floresta
    800: "#2C3E35",   // cinza escuro com verde (usado acima)
    900: "#202A26",   // escuro institucional, profundo e moderno
  },


  gradients: {
    primary: {
      main: "#EC407A",
      state: "#D81B60",
    },

    secondary: {
      main: "#00361F",
      state: "#00361F",
    },

    info: {
      main: "#00361F",
      state: "#00361F",
    },

    success: {
      main: "#66BB6A",
      state: "#43A047",
    },

    warning: {
      main: "#FFA726",
      state: "#FB8C00",
    },

    error: {
      main: "#EF5350",
      state: "#E53935",
    },

    light: {
      main: "#EBEFF4",
      state: "#CED4DA",
    },

    dark: {
      main: "#00361F",
      state: "#191919",
    },
  },

  socialMediaColors: {
    facebook: {
      main: "#3b5998",
      dark: "#344e86",
    },

    twitter: {
      main: "#55acee",
      dark: "#3ea1ec",
    },

    instagram: {
      main: "#125688",
      dark: "#0e456d",
    },

    linkedin: {
      main: "#0077b5",
      dark: "#00669c",
    },

    pinterest: {
      main: "#cc2127",
      dark: "#b21d22",
    },

    youtube: {
      main: "#e52d27",
      dark: "#d41f1a",
    },

    vimeo: {
      main: "#1ab7ea",
      dark: "#13a3d2",
    },

    slack: {
      main: "#3aaf85",
      dark: "#329874",
    },

    dribbble: {
      main: "#ea4c89",
      dark: "#e73177",
    },

    github: {
      main: "#24292e",
      dark: "#171a1d",
    },

    reddit: {
      main: "#ff4500",
      dark: "#e03d00",
    },

    tumblr: {
      main: "#00361F",
      dark: "#2a3749",
    },
  },

  badgeColors: {
    primary: {
      background: "#f8b3ca",
      text: "#cc084b",
    },

    secondary: {
      background: "#00361F",
      text: "#6c757d",
    },

    info: {
      background: "#aecef7",
      text: "#1A3C2B",
    },

    success: {
      background: "#bce2be",
      text: "#339537",
    },

    warning: {
      background: "#ffd59f",
      text: "#c87000",
    },

    error: {
      background: "#fcd3d0",
      text: "#f61200",
    },

    light: {
      background: "#ffffff",
      text: "#c7d3de",
    },

    dark: {
      background: "#8097bf",
      text: "#00361F",
    },
  },

  coloredShadows: {
    primary: "#00361F",
    secondary: "#110e0e",
    info: "#00bbd4",
    success: "#4caf4f",
    warning: "#ff9900",
    error: "#f44336",
    light: "#adb5bd",
    dark: "#404040",
  },

  inputBorderColor: "#d2d6da",

  tabs: {
    indicator: { boxShadow: "#ddd" },
  },
};
